import { CreateReport19Form } from './create-report-19-form'

export const CreateReport19 = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateReport19Form onCloseModal={onCloseModal} />
}
